document.addEventListener('DOMContentLoaded', function() {
  var tabsWrapper = document.querySelector('[data-product-info-tabs]');
  if (!tabsWrapper) return;

  var tabs = tabsWrapper.querySelectorAll('[data-product-info-tab]');
  var panels = document.querySelectorAll('[data-product-info-panel]');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var id = tab.getAttribute('data-product-info-tab');

      tabs.forEach(function(t) {
        t.classList.remove('product-info-tab--active');
      });
      tab.classList.add('product-info-tab--active');

      panels.forEach(function(panel) {
        if (panel.getAttribute('data-product-info-panel') === id) {
          panel.classList.add('product-info-tabs__panel--active');
        } else {
          panel.classList.remove('product-info-tabs__panel--active');
        }
      });
    });
  });
});